import { CustomInput, FormGroup } from 'reactstrap';
import { Filter } from '../../ListMessagesBuilder.styles';
import { useGlotaT } from '../../../../../../hooks/useGlotaTranslation';

interface FilterTypeProps {
  handleChangeTypeFilter(value: any): void;
  typeValue: string;
}

export function FilterType(props: FilterTypeProps) {
  const allTypesText = useGlotaT('spa.tools.allTypes');
  const templatesText = useGlotaT('spa.tools.templates');
  const quickMessagesText = useGlotaT('spa.tools.quickMessagesFilter');
  const listMessagesText = useGlotaT('spa.tools.listMessagesFilter');
  const interactiveButtonsText = useGlotaT('spa.tools.interactiveButtons');
  const filterByTypeText = useGlotaT('spa.tools.filterByType');
  
  return (
    <Filter>
      <FormGroup>
        <CustomInput
          type="select"
          id="filter-type"
          name="customSelectType"
          value={props.typeValue}
          onChange={props.handleChangeTypeFilter}
        >
          <optgroup label={filterByTypeText}>
            <option value="all">{allTypesText}</option>
            <option value="template">{templatesText}</option>
            <option value="quick_message">{quickMessagesText}</option>
            <option value="list">{listMessagesText}</option>
            <option value="buttons">{interactiveButtonsText}</option>
          </optgroup>
        </CustomInput>
      </FormGroup>
    </Filter>
  );
}
